import script from "./DashboardCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCourses.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCourses.vue?vue&type=style&index=0&id=37d38022&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d38022"]])

export default __exports__